import { css } from '@emotion/react';
import { theme } from '@src/common/styles/Theme';

export const globalStyle = css`
  body {
    color: ${theme.palette.surface.onSurface};
    background-color: ${theme.palette.surface.surface};
  }
`;
